import React from "react"
import styled from "styled-components"

const ContentWrapper = styled.div`
  width: 100%;
  background-color: #ffcc06;
  padding: 0.8rem;
  text-align: center;
`

const List = styled.ul`
  liststyle: none;
  margin: 0;
`

const InlineListItem = styled.li`
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 1.2rem;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 0;
  margin-left: 1.2rem;
  &:first-child {
    margin-left: 0rem;
  }
  & a {
    color: white;
  }
  & a:hover {
    color: #202c6a;
  }
`

const ListItem = props => (
  <InlineListItem>
    <a href={props.to}>{props.children}</a>
  </InlineListItem>
)

const SiteMenu = () => (
  <ContentWrapper>
    <List>
      <ListItem to="/about/">누구</ListItem>
      <ListItem to="/">최신 글</ListItem>
      <ListItem to="/posts/">모든 글</ListItem>
      <ListItem to="/tags/">태그</ListItem>
    </List>
  </ContentWrapper>
)

export default SiteMenu
